import { Bar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;
import Chart from 'chart.js'

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    Chart.defaults.global.defaultFontFamily = 'Open Sans';
    Chart.defaults.global.defaultFontColor = '#28275D';
    Chart.defaults.global.elements.rectangle.borderWidth = 0;
    Chart.Legend.prototype.afterFit = function() {
      this.height = this.height + 20;
    };
    this.renderChart(this.chartData, this.options);
  }
};
